package com.ijoin.data.model

import kotlinx.serialization.Serializable

@Serializable
data class User(
    val id: String,
    val email: String,
    val username: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val phone: String? = null,
    val avatarUrl: String? = null,
    val organizer: Boolean = false,
    val organizationName: String? = null,
    val organizationDescription: String? = null,
    val active: Boolean = true,
    val language: String? = null,
    val currency: String = "USD"
)

@Serializable
data class CreateUserRequest(
    val email: String,
    val username: String,
    val password: String,
    val organizer: Boolean = false
)
